import * as locStrings from '../components/InsightDocRow.locstring.json';
import loc, { format } from 'owa-localize';
import type { EmailInsightType, FileInsightType } from 'owa-meeting-insights-types-and-flights';

export function getFileInsightAriaLabel(file: FileInsightType): string {
    const senderText = file.senderName || file.senderEmailAddress;
    const { timestamp, lastActivityType, fileFullName } = file;

    const actionText =
        lastActivityType === 'send'
            ? loc(locStrings.sentAtLabelLowerCase)
            : loc(locStrings.modifiedAtLabelLowerCase);

    return format(
        loc(locStrings.fileAriaLabel),
        fileFullName,
        format(actionText, timestamp),
        senderText
    );
}

export function getEmailInsightAriaLabel(email: EmailInsightType, includePreview: boolean): string {
    const senderText = email.senderName || email.senderEmailAddress;
    const { sentTimestamp, subject, preview, isRead } = email;

    return format(
        loc(locStrings.emailAriaLabel),
        subject,
        format(loc(locStrings.sentAtLabelLowerCase), sentTimestamp),
        senderText,
        isRead ? loc(locStrings.readStatusLabel) : loc(locStrings.unreadStatusLabel),
        includePreview ? format(loc(locStrings.previewLabel), preview) : ''
    );
}
